import { render, staticRenderFns } from "./legal.vue?vue&type=template&id=760467bf&scoped=true&"
import script from "./legal.vue?vue&type=script&lang=ts&"
export * from "./legal.vue?vue&type=script&lang=ts&"
import style0 from "./legal.vue?vue&type=style&index=0&id=760467bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760467bf",
  null
  
)

export default component.exports